// extracted by mini-css-extract-plugin
export const twoColumnHeroStyles = "twoColumnHero-module--twoColumnHeroStyles--rCO9S";